/** Page Designer component type for a footer link column container. */
export const FOOTER_LINK_LIST_TYPE_ID = 'footerLinkList';

/** Page Designer component type for a single footer link. */
export const FOOTER_LINK_TYPE_ID = 'footerLink';

/** Page Designer component type for the social media icon list container. */
export const FOOTER_SOCIAL_MEDIA_ICON_LIST_TYPE_ID = 'footerSocialMediaIconList';

/** Page Designer component type for a single social media icon. */
export const FOOTER_SOCIAL_MEDIA_ICON_TYPE_ID = 'footerSocialMediaIcon';

/** Page Designer component type for the payment method icon list container. */
export const FOOTER_PAYMENT_METHOD_ICON_LIST_TYPE_ID = 'footerPaymentMethodIconList';

/** Page Designer component type for a single payment method icon. */
export const FOOTER_PAYMENT_METHOD_ICON_TYPE_ID = 'footerPaymentMethodIcon';

/** Global content slot region ID for social media icons in the footer. */
export const FOOTER_SOCIAL_MEDIA_REGION_ID = 'socialMediaIcons';

/** Global content slot region ID for payment method icons in the footer. */
export const FOOTER_PAYMENT_METHOD_REGION_ID = 'paymentMethodIcons';

/** Global content slot region IDs for the five footer link columns. */
export const FOOTER_LINK_REGION_IDS = [
    'footerRegion01',
    'footerRegion02',
    'footerRegion03',
    'footerRegion04',
    'footerRegion05',
] as const;

export type FooterLinkRegionId = (typeof FOOTER_LINK_REGION_IDS)[number];
